import { Box, CircularProgress, SxProps, Tooltip, useTheme } from '@mui/material';

// eslint-disable-next-line import/named
import { path } from 'lodash/fp';

import { IconConfig } from '../../../types';
import { styles } from '../styles';

const DefaultIconWithLoader = ({ Icon, isLoading, disabled = false, onClick, color, tooltip, sx = {} }: IconConfig) => {
  const theme = useTheme();
  const themeColor = color ? path(['palette', color, 'main'], theme) : undefined;

  if (!Icon) return null;

  return (
    <Box onClick={!disabled && !!onClick ? onClick : undefined} sx={{ ...styles.container, ...sx } as SxProps}>
      <Tooltip title={tooltip} arrow>
        <Icon sx={styles.icon(disabled ? 'action.disabled' : themeColor)} />
      </Tooltip>
      {isLoading && <CircularProgress />}
    </Box>
  );
};

export default DefaultIconWithLoader;
